import { reset as resetOtuVision } from '../../redux/otuVision/actions'
import { reset as resetClassrooms } from '../../redux/classrooms/actions'
import { reset as resetGym } from '../../redux/gym/actions'
import { reset as resetMission } from '../../redux/mission/actions'
import { reset as resetNotifications } from '../../redux/notifications/actions'
import { reset as resetTeam } from '../../redux/team/actions'
import { reset as resetWorkoutTogether } from '../../redux/workoutTogether/actions'


export function reset ( options = {} ) {
  
  return (dispatch, getState) => {
    dispatch( resetOtuVision() )
    dispatch( resetClassrooms() )
    dispatch( resetGym() )
    dispatch( resetMission() )
    dispatch( resetNotifications() )
    dispatch( resetTeam() )
    dispatch( resetWorkoutTogether() )
  }

}